<template>
  <div class="inline-block topic-card">
    <div class="bg-white p-10 pt-20 relative flex items-end"
        :class="{ 'shadow': shadow }"
        style="min-height: 290px; border-radius: 2rem;">
      <div style="width: 80%; z-index: 2;" class="reative">
        <div class="text-left text-xl font-bold mt-10">{{ label }}</div>
        <div class="text-left text-base mt-1" style="color: #A7A7A7">{{ caption }}</div>
      </div>
      <div class="img-container">
        <slot name="bg-image"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    caption: String,
    label: String,
    shadow: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.img-container {
  position: absolute;
  right: 1.25rem;
  top: 1.25rem;
  width: 40%;
}

.topic-card:hover {
  animation: shake .7s alternate 1;
  animation-timing-function: ease-out;
}

@keyframes shake {
  0% { transform: translate(1px, 1px) rotate(0deg) scale(1.1); }
  10% { transform: translate(-1px, -2px) rotate(-1deg) scale(1.2); }
  20% { transform: translate(-3px, 0px) rotate(1deg) scale(1.1); }
  30% { transform: translate(3px, 2px) rotate(0deg) scale(1); }
  40% { transform: translate(1px, -1px) rotate(1deg) scale(1); }
  50% { transform: translate(-1px, 2px) rotate(-1deg); }
  60% { transform: translate(-3px, 1px) rotate(0deg); }
  70% { transform: translate(3px, 1px) rotate(-1deg); }
  80% { transform: translate(-1px, -1px) rotate(1deg); }
  90% { transform: translate(1px, 2px) rotate(0deg); }
  100% { transform: translate(1px, -2px) rotate(-1deg); }
}
</style>